// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1f6G_","badges":"styles_badges__1FQ36"};